var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Form, Message } from 'semantic-ui-react';
import { beginUpdateUser } from 'app/containers/User/userActions';
import Render from 'components/Render';
import FormLabel from './FormLabel';
import { getFieldsToShow, handleLeadGeneration, OnboardingFlowButton } from './helper';
var AccountSetup = /** @class */ (function (_super) {
    __extends(AccountSetup, _super);
    function AccountSetup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            company: null,
            first_name: null,
            last_name: null,
            fieldsToShow: getFieldsToShow(props.user),
        };
        _this.handleNext = _this.handleNext.bind(_this);
        return _this;
    }
    AccountSetup.prototype.handleNext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, company, first_name, last_name, _b, user, accessToken, handleUpdateUser;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.setState({ isLoading: true });
                        _a = this.state, company = _a.company, first_name = _a.first_name, last_name = _a.last_name;
                        _b = this.props, user = _b.user, accessToken = _b.accessToken, handleUpdateUser = _b.handleUpdateUser;
                        handleUpdateUser({
                            user_metadata: __assign(__assign(__assign({}, (company ? { company: company } : {})), (first_name ? { first_name: first_name } : {})), (last_name ? { last_name: last_name } : {})),
                            user_id: user.sub,
                        });
                        return [4 /*yield*/, handleLeadGeneration({ accessToken: accessToken })];
                    case 1:
                        _c.sent();
                        this.props.onContinue([
                            {
                                key: 'Company',
                                value: company,
                            },
                        ]);
                        return [2 /*return*/];
                }
            });
        });
    };
    AccountSetup.prototype.allowContinue = function () {
        var state = this.state;
        var fieldsToShow = state.fieldsToShow;
        var shouldAllowContinue = fieldsToShow.every(function (item) { return state[item] && state[item] !== ''; });
        return shouldAllowContinue;
    };
    AccountSetup.prototype.render = function () {
        var _this = this;
        var _a = this.state, company = _a.company, first_name = _a.first_name, last_name = _a.last_name, isLoading = _a.isLoading, errorMessage = _a.errorMessage, fieldsToShow = _a.fieldsToShow;
        var allowContinue = this.allowContinue();
        return (React.createElement("div", null,
            React.createElement(Form, { size: "large" },
                React.createElement(Grid, { className: "mt3" },
                    React.createElement(Render, { if: fieldsToShow.indexOf('first_name') > -1 || fieldsToShow.indexOf('last_name') > -1 },
                        React.createElement(Grid.Column, { width: 16, md: 6 },
                            React.createElement(Form.Field, null,
                                React.createElement(Form.Input, { type: "text", className: "mt2", width: 8, value: first_name, onChange: function (e, _a) {
                                        var value = _a.value;
                                        _this.setState({ first_name: value });
                                    }, autoFocus: true, name: "firstName", id: "firstName", label: "First Name" }))),
                        React.createElement(Grid.Column, { width: 16, md: 6 },
                            React.createElement(Form.Field, null,
                                React.createElement(Form.Input, { type: "text", className: "mt2", width: 8, value: last_name, onChange: function (e, _a) {
                                        var value = _a.value;
                                        _this.setState({ last_name: value });
                                    }, name: "lastName", id: "lastName", label: "Last Name" })))),
                    React.createElement(Render, { if: fieldsToShow.indexOf('company') > -1 },
                        React.createElement(Grid.Column, { width: 16, md: 6 },
                            React.createElement(FormLabel, null, "Where do you work?"),
                            React.createElement(Form.Field, null,
                                React.createElement(Form.Input, { type: "text", className: "mt2", width: 8, value: company, onChange: function (e, _a) {
                                        var value = _a.value;
                                        _this.setState({ company: value });
                                    }, autoFocus: fieldsToShow.length === 1, name: "company", id: "company" }))))),
                React.createElement(OnboardingFlowButton, { currentStepIndex: this.props.currentStepIndex, totalSteps: this.props.totalSteps, onClick: this.handleNext, isLoading: isLoading, isDisabled: !allowContinue }),
                React.createElement(Render, { if: errorMessage && errorMessage.length > 0 },
                    React.createElement("p", { className: "mt3 error" },
                        React.createElement(Message, { negative: true }, errorMessage))))));
    };
    return AccountSetup;
}(Component));
var mapStateToProps = function (state) { return ({
    user: state.user,
    accessToken: state.user.accessToken,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    handleUpdateUser: function (user) { return dispatch(beginUpdateUser(user)); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(AccountSetup);
